<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <PrestigePicker
      :label="$t('calculators_common.current_prestige')"
      itemKey="currentPrestige"
    />
    <PrestigePicker
      :label="$t('calculators_common.desired_prestige')"
      itemKey="desiredPrestige"
    />
    <!-- <PrestigeRankPicker
      :type="'currentPrestige'"
      item-key="prestigeBoosting"
      :title="$t('calculators_common.current_prestige')"
      class="flex-5 flex-lg-10"
    />
    <PrestigeRankPicker
      :type="'desiredPrestige'"
      item-key="prestigeBoosting"
      :title="$t('calculators_common.desired_prestige')"
      :prev-rank="getDetails?.currentPrestige"
      class="flex-5 flex-lg-10"
    /> -->
  </div>
  <PrestigeLevelPicker />
  <ExtraOptionPicker />
  <PlatformPicker />
</template>

<script setup>
import PlatformPicker from "../../commonpickers/PlatformPicker.vue";
import PrestigeLevelPicker from "../pickers/PrestigeLevelPicker.vue";
import PrestigePicker from "../pickers/PrestigePicker.vue";
import ExtraOptionPicker from "../pickers/ExtraOptionPicker.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const prestigeLvl = gameStore.getGamePack?.prices[0] || null;
  checkoutStore.setPlatform({
    platform: 1,
  });
  // if (prestigeLvl) {
  //   checkoutStore.setDetails({
  //     currentDivisionTitle: "Prestige Level 1",
  //     currentPrestige: prestigeLvl?.id,
  //     desiredDivisionTitle: "Prestige Level 1",
  //     desiredPrestige: prestigeLvl?.id,
  //     rankFrom: 1,
  //     rankTo: 55,
  //   });
  // }
  if (prestigeLvl) {
    checkoutStore.setDetails({
      currentPrestige: prestigeLvl?.id,
      desiredPrestige: prestigeLvl?.id,
      currentPrestigeLevel: 1,
      currentPrestigeTitle: prestigeLvl?.title,
      desiredPrestigeTitle: prestigeLvl?.title,
      desiredPrestigeLevel: 55,
    });
  }
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
